import { render, staticRenderFns } from "./InnerTab.vue?vue&type=template&id=4d47fd3a&scoped=true"
import script from "./InnerTab.vue?vue&type=script&lang=js"
export * from "./InnerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d47fd3a",
  null
  
)

export default component.exports